import { gql } from "@apollo/client";

const CAN_MANAGE_PROFILE = gql`
  query canManageProfileQuery($id: ID!) {
    canManageProfile(id: $id) {
      authorized
    }
  }
`;

export default CAN_MANAGE_PROFILE;
